/* eslint-disable func-names */
import { LOAD_MAP, CLEAR_ACTION, FETCH_PORTAL_TILES, ADD_SUBSCRIPTION, FETCH_PORTAL_TILES_ALINGMENT } from './types';

const INITIAL_STATE = {
  fetchPortalTileAction: { loading: false, success: false, error: false },
  postPortalTileActionSubscription: { loading: false, success: false, error: false },
  portalTilesList: [],
  displayMaintenanceWorkOrders: undefined,
  documentEnabled: undefined,
  invoiceEnabled: undefined,
  trainingEnabled: undefined
};

export default function (state=INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_PORTAL_TILES.pending:
      return {
        ...state,
        fetchPortalTileAction: { loading: true, success: false, error: false }
      };
    case FETCH_PORTAL_TILES.success: {
      const Maintenance_checked = action.payload.filter(data => data.tile_name === 'Maintenance Requests');
      const myInspections_checked = action.payload.find(data => data.tile_name === 'My Inspections')?.visibility;
      const myForms_checked = action.payload.find(data => data.tile_name === 'My Forms')?.visibility;
      const shared_docs_checked = action.payload.find(data => data.tile_name === 'Shared Documents')?.visibility;
      const documnet_checked = action.payload.filter(data => data.tile_name === 'Documents')[0]?.visibility;
      const invoice_checked = action.payload.filter(data => data.tile_name === 'Invoice')[0]?.visibility;
      const subscription_checked = action.payload.filter(data => data.tile_name === 'Subscriptions')[0]?.visibility;
      const isEnabled = Maintenance_checked[0]?.visibility;
      const training_checked = action.payload.filter(data => data.tile_name === 'My Training')[0]?.visibility;
      const smsSafeChecked = action.payload.filter(data => data.tile_name === 'Safety Promotions')[0]?.visibility;
      const snowpriorityzone = action.payload.find(data => data.tile_name === 'Snow Priority Zones')?.visibility;
      return {
        ...state,
        fetchPortalTileAction: { loading: false, success: true, error: false },
        portalTilesList: action.payload,
        displayMaintenanceWorkOrders: isEnabled,
        documentEnabled: documnet_checked,
        invoiceEnabled: invoice_checked,
        subscription: subscription_checked,
        trainingEnabled: training_checked,
        smsSafetyPromEnabled: smsSafeChecked,
        isInspectionsEnabled: myInspections_checked,
        isSharedDcosEnabled: shared_docs_checked,
        isMyFormsEnabled: myForms_checked,
        snowPriorityZoneEnabled: snowpriorityzone
      };
    }
    case FETCH_PORTAL_TILES.error:
      return {
        ...state,
        fetchPortalTileAction: { loading: false, success: false, error: true }
      };

    case CLEAR_ACTION:
      return {
        ...state,
        fetchPortalTileAction: { loading: false, success: false, error: false }
      };

    case ADD_SUBSCRIPTION.pending: {
      return {
        ...state,
        postPortalTileActionSubscription: { loading: true, success: false, error: false }
      };
    }
    case ADD_SUBSCRIPTION.success: {
      return {
        ...state,
        postPortalTileActionSubscription: { loading: false, success: true, error: false },
        subscribePortile: action.payload
      };
    }
    case ADD_SUBSCRIPTION.error: {
      return {
        ...state,
        postPortalTileActionSubscription: { loading: false, success: false, error: true }
      };
    }
    case FETCH_PORTAL_TILES_ALINGMENT.pending: {
      return {
        ...state,
        fetchPortalTileAlingmentAction: { loading: true, success: false, error: false }
      };
    }
    case FETCH_PORTAL_TILES_ALINGMENT.success: {
      return {
        ...state,
        fetchPortalTileAlingmentAction: { loading: false, success: true, error: false },
        portalTilesAlingment: action.payload
      };
    }
    case FETCH_PORTAL_TILES_ALINGMENT.error: {
      return {
       ...state,
        fetchPortalTileAlingmentAction: { loading: false, success: false, error: true }
      };
    }
     case LOAD_MAP.pending: {
      return {
        ...state,
        list_action: { loading: true, success: false, error: false }
      };
    }
    case LOAD_MAP.success: {
      return {
        ...state,
        surfaces: action.payload.results,
        list_action: { loading: false, success: true, error: false }
      };
    }
    case LOAD_MAP.error: {
      return {
        ...state,
        list_action: { loading: false, success: false, error: true }
      };
    }
    default:
      return state;
  }
}
